export class RsncdDlyProg {
  id: number;
  calrule_id: number;
  reasoncode_id: number;
  reasoncodeDescr: string;
  dailyprog_id: number;
  dailyprogDescr: string;
  isEdit: boolean;
}

export const RsncdDlyProgProgColumns = [
  {
    key: 'reasoncode_id',
    type: 'select',
    required: true,
  },
  {
    key: 'reasoncodeDescr',
    type: 'text',
    readonly: true
  },
  {
    key: 'daily_prog_id',
    type: 'select',
    required: true,
  },
  {
    key: 'dailyProgDescr',
    type: 'text',
    readonly: true
  },
  {
    key: 'isEdit',
    type: 'isEdit',
    label: '',
  }
];


